module.exports = __webpack_public_path__ + "static/media/craft_sold_item_second.6b91a6bf.mp3";